/* Reef Safe Ingredient Checker – standalone, no React */
(function () {
  'use strict';

  var SESSION_ID = (function () {
    var c = document.cookie.split('; ').filter(function (r) { return r.startsWith('_shopify_y='); })[0];
    if (c) return c.split('=')[1];
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  })();

  var currentResult = null;
  var currentNanoIngredients = [];

  /* ── API ── */
  function apiPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (e) { throw new Error(e.message || 'Request failed.'); });
      return res.json();
    });
  }

  function apiCheckIngredients(ingredients, productName, isNano) {
    return apiPost('https://api.chosenstore.in/kys/check-reef-safe-ingredients', {
      ingredients: ingredients, productName: productName, isNano: isNano, kysSessionId: SESSION_ID,
    });
  }

  function apiScanImage(image, fileName, productName, isNano) {
    return apiPost('https://api.chosenstore.in/kys/reef-scan', {
      image: image, fileName: fileName, productName: productName, isNano: isNano, kysSessionId: SESSION_ID,
    });
  }

  function fileToBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onloadend = function () { resolve(reader.result); };
      reader.onerror = function () { reject(new Error('Failed to read file.')); };
      reader.readAsDataURL(file);
    });
  }

  function detectNano(text) {
    return text.split(',').map(function (s) { return s.trim(); }).filter(function (s) {
      var l = s.toLowerCase();
      return (l.includes('titanium oxide') || l.includes('titanium dioxide') || l.includes('zinc oxide')) && !l.includes('nano');
    });
  }
  function sortIngredientsByInputOrder(apiIngredients, inputText) {
    if (!inputText || !apiIngredients) return apiIngredients;

    var inputOrder = inputText
      .split(',')
      .map(function (item) {
        return item.trim().toUpperCase();
      })
      .filter(Boolean);

    return apiIngredients.slice().sort(function (a, b) {
      var aIndex = inputOrder.indexOf((a.name || '').trim().toUpperCase());
      var bIndex = inputOrder.indexOf((b.name || '').trim().toUpperCase());

      if (aIndex === -1) aIndex = 9999;
      if (bIndex === -1) bIndex = 9999;

      return aIndex - bIndex;
    });
  }
  /* ── Right panel helpers ── */
  function rightPanel() { return document.getElementById('reef-v2-right'); }

  function setRight(cls, html) {
    var r = rightPanel();
    if (!r) return;
    r.className = 'reef-v2-right' + (cls ? ' ' + cls : '');
    r.innerHTML = html;
  }

  var WAIT_HTML =
    '<div class="reef-v2-waiting">' +
    '<div class="reef-v2-waiting-icon"><svg viewBox="0 0 24 24" fill="none" stroke="#bdbdbd" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="52" height="52"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg></div>' +
    '<strong class="reef-v2-waiting-title">Waiting for analysis</strong>' +
    '<p class="reef-v2-waiting-desc">Enter your sunscreen ingredients to see if they\'re reef safe</p>' +
    '</div>';

  function showWaiting() { setRight('', WAIT_HTML); }

  function showLoading() {
    setRight('reef-v2-right--loading',
      '<div class="reef-v2-loading"><div class="reef-loading-spinner"></div><p>Analyzing ingredients…</p></div>');
  }

  function showError(msg) {
    setRight('reef-v2-right--active',
      '<div class="reef-v2-error">' +
      '<div class="reef-v2-error-icon">⚠</div>' +
      '<p>' + escHtml(msg) + '</p>' +
      '<button class="reef-try-again-btn" id="reef-reset-btn">Try again</button>' +
      '</div>');
    var btn = document.getElementById('reef-reset-btn');
    if (btn) btn.addEventListener('click', showWaiting);
  }

  function showInconclusive(data, ingredientsText) {
    var count = 0;
    if (ingredientsText) {
      count = ingredientsText.split(',').map(function (s) { return s.trim(); }).filter(function (s) { return s.length > 0; }).length;
    } else {
      count = (data && data.ingredients && data.ingredients.length) || 0;
    }
    var ingWord = count === 1 ? 'ingredient' : 'ingredients';
    setRight('reef-v2-right--inconclusive',
      '<div class="reef-inc-card">' +
      '<div class="reef-pc-header">' +
      '<div class="reef-pc-icon reef-pc-icon--question">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-help size-8 text-white"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><path d="M12 17h.01"></path></svg>' +
      '</div>' +
      '<div>' +
      '<strong class="reef-pc-title">Inconclusive</strong>' +
      '<span class="reef-pc-sub">' + count + ' ' + ingWord + ' checked</span>' +
      '</div>' +
      '</div>' +
      '<hr class="reef-pc-divider reef-pc-divider--orange">' +
      '<div class="reef-pc-body">' +
      '<div class="reef-inc-info-box">' +
      '<p>We couldn\'t verify the reef safety of these ingredients. This doesn\'t mean they\'re safe or harmful.</p>' +
      '<p class="reef-inc-info-sub">Try checking the manufacturer\'s website or reach out to them directly for reef-safety information.</p>' +
      '</div>' +
      '<div class="reef-inc-tip-box"><strong>Tip:</strong> Look for &ldquo;reef safe&rdquo; or &ldquo;reef friendly&rdquo; certifications from recognized marine conservation organizations.</div>' +
      '</div>' +
      '</div>');
  }

  function showLivePreview(count) {
    var ingWord = count === 1 ? 'ingredient' : 'ingredients';
    setRight('reef-v2-right--preview',
      '<div class="reef-preview-card">' +
      '<div class="reef-pc-header">' +
      '<div class="reef-pc-icon reef-pc-icon--shield">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="#888" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" width="22" height="22"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' +
      '</div>' +
      '<div>' +
      '<strong class="reef-pc-title">Live Preview</strong>' +
      '<span class="reef-pc-sub">' + count + ' ' + ingWord + ' detected</span>' +
      '</div>' +
      '</div>' +
      '<hr class="reef-pc-divider">' +
      '<div class="reef-pc-body">' +
      '<div class="reef-pc-notfound-box"><strong>' + count + ' ' + ingWord + '</strong> entered &mdash; ready for reef safety analysis</div>' +
      '<p class="reef-pc-cta">Click &ldquo;Check ingredients&rdquo; for full analysis</p>' +
      '</div>' +
      '</div>');
  }

  function escHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function showNanoConfirm(nanoList) {
    var names = nanoList.map(function (n) { return n.charAt(0).toUpperCase() + n.slice(1); }).join(', ');
    setRight('reef-v2-right--active',
      '<div class="reef-nano-confirm">' +
      '<h2>Let\'s talk ingredients.</h2>' +
      '<p>We\'ve found mineral filter(s) that <em>may</em> be reef-unsafe in nano form: <strong>' + escHtml(names) + '</strong>.</p>' +
      '<p>Does your label say <b>"Non-Nano ' + escHtml(names) + '"</b>?</p>' +
      '<div class="reef-radio-group">' +
      '<label class="reef-radio-item"><input type="radio" name="reef-nano" value="nano"><span>It\'s Nano</span></label>' +
      '<label class="reef-radio-item"><input type="radio" name="reef-nano" value="non-nano"><span>It\'s Non-Nano</span></label>' +
      '<label class="reef-radio-item"><input type="radio" name="reef-nano" value="not-mentioned"><span>It does not specify</span></label>' +
      '</div>' +
      '<div id="reef-nano-error" class="reef-error-msg" style="display:none"></div>' +
      '<button class="reef-submit-btn" id="reef-nano-confirm-btn">Submit</button>' +
      '</div>');

    var r = rightPanel();
    var submitBtn = document.getElementById('reef-nano-confirm-btn');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        var sel = r && r.querySelector('input[name="reef-nano"]:checked');
        if (!sel) {
          var errEl = document.getElementById('reef-nano-error');
          if (errEl) { errEl.textContent = 'Please select one option.'; errEl.style.display = 'block'; }
          return;
        }
        showResults(currentResult, sel.value);
        triggerSections(true);
      });
    }
  }

  function buildResultHTML(data, nanoData) {
    var ingredients = data.ingredients || [];
    var redList = ingredients.filter(function (ing) {
      if (ing.ecological_concerns_flag_color !== 'red') return false;
      if (nanoData === 'non-nano') {
        var l = ing.name.toLowerCase();
        if (l.includes('titanium oxide') || l.includes('titanium dioxide') || l.includes('zinc oxide')) return false;
      }
      return true;
    });
    var safe = redList.length === 0;
    var h = '<div class="reef-result-inner"><h2 class="reef-result-title">Your Sunscreen Report</h2>';

    if (safe) {
      h += '<div class="reef-flags-wrap reef-flags--green"><h3>GREEN FLAGS</h3>';
      if (nanoData === 'non-nano') {
        h += '<p>This is a <span class="reef-text-green">' + escHtml(data.sunscreenType || 'mineral') + '</span> sunscreen and uses <b>Non-Nano</b> Mineral Filters — safe for reefs and marine life.</p>';
        h += '<h3>What this means:</h3><p>Mineral sunscreens like this one are generally considered reef-safe and ocean-friendly.</p>';
      } else {
        h += '<p>This is a <span class="reef-text-green">' + escHtml(data.sunscreenType || 'reef-safe') + '</span> sunscreen and is considered <span class="reef-text-green">reef-safe</span>.</p>';
        h += '<p>It is safe for the ocean and marine life.</p>';
      }
      h += '</div>';
    } else {
      h += '<div class="reef-flags-wrap reef-flags--red"><h3>RED FLAGS</h3>';
      if (nanoData === 'not-mentioned') {
        h += '<p>Your sunscreen does not specify nano/non-nano, making it potentially <span class="reef-text-red">reef-unsafe</span>.</p>';
        h += '<p>These <b>nano</b> particles can be toxic to coral reefs, leading to bleaching and long-term damage.</p>';
      }
      h += '<p>Your sunscreen contains ingredients that may be <span class="reef-text-red">harmful</span> to coral reefs or marine life.</p>';
      if (nanoData === 'nano') {
        h += '<h3>Why this matters:</h3><p>Certain UV filters, especially in <b>nano</b> form, can disrupt delicate ocean ecosystems. We recommend switching to a reef-safe mineral sunscreen.</p>';
      }
      h += '</div>';

      if (redList.length > 0) {
        h += '<div class="reef-accordion">';
        redList.forEach(function (ing, idx) {
          h += '<div class="reef-accordion-item">' +
            '<button class="reef-accordion-btn" data-idx="' + idx + '">' +
            '<span class="reef-ing-label"><span class="reef-red-dot"></span><strong>' + escHtml(ing.name) + '</strong> (' + escHtml(ing.symbol) + ') &ndash; ' + escHtml(ing.type) + '</span>' +
            '<span class="reef-accordion-icon">+</span>' +
            '</button>' +
            '<div class="reef-accordion-body" style="display:none"><p>' + escHtml(ing.ecological_concerns_flag) + '</p></div>' +
            '</div>';
        });
        h += '</div>';
      }
    }
    h += '</div>';
    return h;
  }

  function showResults(data, nanoData) {
    setRight('reef-v2-right--results-active', buildResultHTML(data, nanoData));
    var r = rightPanel();
    if (!r) return;
    r.querySelectorAll('.reef-accordion-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = this.parentNode.querySelector('.reef-accordion-body');
        var icon = this.querySelector('.reef-accordion-icon');
        var open = body.style.display !== 'none';
        r.querySelectorAll('.reef-accordion-body').forEach(function (b) { b.style.display = 'none'; });
        r.querySelectorAll('.reef-accordion-icon').forEach(function (i) { i.textContent = '+'; });
        if (!open) { body.style.display = 'block'; icon.textContent = '−'; }
      });
    });
  }

  function triggerSections(isShow) {
    if (typeof window.showHideRecommendationSection === 'function') window.showHideRecommendationSection(isShow);
    if (isShow && typeof window.initiateRecommendationSlider === 'function') window.initiateRecommendationSlider(true);
  }

  // function processResult(data, ingredientsText) {
  //   if (data.message !== 'Success') { showInconclusive(data, ingredientsText); triggerSections(true); return; }
  //   currentResult = data;
  //   currentNanoIngredients = detectNano(ingredientsText || '');
  //   if (currentNanoIngredients.length > 0) {
  //     showNanoConfirm(currentNanoIngredients);
  //   } else {
  //     showResults(data, '');
  //     triggerSections(true);
  //   }
  // }
  function processResult(data, ingredientsText) {
    if (data.message !== 'Success') {
      showInconclusive(data, ingredientsText);
      triggerSections(true);
      return;
    }

    data.ingredients = sortIngredientsByInputOrder(
      data.ingredients,
      ingredientsText
    );

    currentResult = data;
    currentNanoIngredients = detectNano(ingredientsText || '');

    if (currentNanoIngredients.length > 0) {
      showNanoConfirm(currentNanoIngredients);
    } else {
      showResults(data, '');
      triggerSections(true);
    }
  }
  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', function () {
    showWaiting();

    /* Tabs */
    var pastePanel = document.getElementById('reef-paste-panel');
    var uploadPanel = document.getElementById('reef-upload-panel');
    document.querySelectorAll('.reef-v2-tab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.reef-v2-tab').forEach(function (b) { b.classList.remove('reef-v2-tab--active'); });
        this.classList.add('reef-v2-tab--active');
        var t = this.getAttribute('data-reftab');
        if (pastePanel) pastePanel.style.display = t === 'paste' ? '' : 'none';
        if (uploadPanel) uploadPanel.style.display = t === 'upload' ? '' : 'none';
      });
    });

    /* ── Paste tab ── */
    var pasteTA = document.getElementById('reef-ingredients');
    var pasteBtn = document.getElementById('reef-check-btn');
    var clearBtn = document.getElementById('reef-clear-btn');

    var livePreviewTimer = null;
    if (pasteTA && pasteBtn) {
      pasteTA.addEventListener('input', function () {
        var val = this.value.trim();
        pasteBtn.disabled = val === '';
        clearTimeout(livePreviewTimer);
        if (!val) { showWaiting(); triggerSections(false); return; }
        livePreviewTimer = setTimeout(function () {
          var count = val.split(',').map(function (s) { return s.trim(); }).filter(function (s) { return s.length > 0; }).length;
          showLivePreview(count);
        }, 300);
      });

      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          pasteTA.value = '';
          var pn = document.getElementById('reef-product-name');
          if (pn) pn.value = '';
          pasteBtn.disabled = true;
          showWaiting();
          triggerSections(false);
        });
      }

      pasteBtn.addEventListener('click', function () {
        var ingredients = pasteTA.value.trim();
        if (!ingredients) return;
        var pn = document.getElementById('reef-product-name');
        pasteBtn.disabled = true;
        pasteBtn.textContent = 'Analyzing…';
        showLoading();
        apiCheckIngredients(ingredients, pn ? pn.value.trim() : '', '').then(function (data) {
          processResult(data, ingredients);
          triggerSections(true);
        }).catch(function (err) {
          showError(err.message || 'An error occurred.');
        }).finally(function () {
          pasteBtn.textContent = 'Check ingredients';
          pasteBtn.disabled = pasteTA.value.trim() === '';
        });
      });
    }

    /* ── Upload tab ── */
    var fileInput = document.getElementById('reef-file-input');
    var dropZone = document.getElementById('reef-drop-zone');
    var uploadBtn = document.getElementById('reef-upload-btn');
    var filePreview = document.getElementById('reef-file-preview');
    var uploadClearBtn = document.getElementById('reef-upload-clear-btn');

    function updateUploadBtn() {
      if (uploadBtn) uploadBtn.disabled = !fileInput || !fileInput.files || fileInput.files.length === 0;
    }

    function applyFile(file) {
      if (!file) return;
      try { var dt = new DataTransfer(); dt.items.add(file); if (fileInput) fileInput.files = dt.files; } catch (e) {}
      if (filePreview) { filePreview.textContent = '📎 ' + file.name; filePreview.style.display = 'block'; }
      updateUploadBtn();
    }

    if (fileInput) fileInput.addEventListener('change', function () { if (this.files[0]) applyFile(this.files[0]); });

    if (dropZone) {
      dropZone.addEventListener('click', function () { if (fileInput) fileInput.click(); });
      dropZone.addEventListener('dragover', function (e) { e.preventDefault(); this.classList.add('reef-drop-zone--hover'); });
      dropZone.addEventListener('dragleave', function () { this.classList.remove('reef-drop-zone--hover'); });
      dropZone.addEventListener('drop', function (e) {
        e.preventDefault(); this.classList.remove('reef-drop-zone--hover');
        var f = e.dataTransfer.files[0]; if (f) applyFile(f);
      });
    }

    if (uploadClearBtn) {
      uploadClearBtn.addEventListener('click', function () {
        if (fileInput) fileInput.value = '';
        if (filePreview) { filePreview.textContent = ''; filePreview.style.display = 'none'; }
        var pn = document.getElementById('reef-product-name-upload');
        if (pn) pn.value = '';
        updateUploadBtn();
        showWaiting();
        triggerSections(false);
      });
    }

    if (uploadBtn) {
      uploadBtn.addEventListener('click', function () {
        var file = fileInput && fileInput.files && fileInput.files[0];
        if (!file) return;
        var pn = document.getElementById('reef-product-name-upload');
        uploadBtn.disabled = true;
        uploadBtn.textContent = 'Analyzing…';
        showLoading();
        fileToBase64(file).then(function (b64) {
          return apiScanImage(b64, file.name, pn ? pn.value.trim() : '', '');
        }).then(function (data) {
          var txt = (data.ingredients || []).map(function (i) { return i.name; }).join(', ');
          processResult(data, txt);
          triggerSections(true);
        }).catch(function (err) {
          showError(err.message || 'An error occurred.');
        }).finally(function () {
          uploadBtn.textContent = 'Check ingredients';
          updateUploadBtn();
        });
      });
    }
  });
})();
